import * as React from "react";
import { Modal, Fade, Box, Typography, IconButton } from "@mui/material";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import GppMaybeRoundedIcon from "@mui/icons-material/GppMaybeRounded";
import PrintIcon from "@mui/icons-material/Print";
import Theme from "../utils/MuiThemePalette";

function ModalComponent(props) {
  const {
    open,
    handleClose,
    style,
    headerText,
    bodyStyle,
    bodyComponent,
    isWarning,
    modalStyles,
    handlePrint,
    isSticky,
    stickyHeader = false,
  } = props;

  const theme = Theme();

  const baseModalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    boxShadow: 24,
    "&::-webkit-scrollbar": {
      width: "0px",
      height: "0px",
      backgroundColor: "rgba(0, 0, 0, 0.06)",
    },
  };

  const mergedStyles = { ...baseModalStyle, ...modalStyles, ...style };

  return (
    <Modal open={open} onClose={handleClose} closeAfterTransition>
      <Fade in={open}>
        {stickyHeader ? (
          // ✅ Sticky Header Mode
          <Box
            sx={{
              ...mergedStyles,
              width: "100%",
              maxWidth: 800,
              maxHeight: "90vh",
              bgcolor: "background.paper",
              borderRadius: "16px",
              display: "flex",
              flexDirection: "column",
            }}
            className={bodyStyle}
          >
            {/* Sticky Header */}
            <Box
              className="flex w-full items-center justify-between px-2 rounded-t-16"
              sx={{
                backgroundColor: theme.custom?.primary_icon || "#0967D2",
                position: "sticky",
                top: 0,
                zIndex: 10,
                borderTopLeftRadius: "16px",
                borderTopRightRadius: "16px",
              }}
            >
              <div className="flex w-full flex-row items-center justify-start">
                {isWarning && (
                  <>
                    <GppMaybeRoundedIcon sx={{ fontSize: "40px", color: "#DE911D" }} />
                    <Box sx={{ m: 1 }} />
                  </>
                )}
                <Typography className="text-xl font-bold text-white" sx={{ color: theme.custom?.heading }}>
                  {headerText}
                </Typography>
              </div>

              <div className="flex gap-x-5">
                {handlePrint && (
                  <IconButton onClick={handlePrint}>
                    <PrintIcon style={{ color: "white", fontSize: "24px" }} />
                  </IconButton>
                )}
                <IconButton onClick={handleClose}>
                  <CloseOutlinedIcon style={{ color: "white", fontSize: "24px" }} />
                </IconButton>
              </div>
            </Box>

            {/* Scrollable Body */}
            <Box
              sx={{
                overflowY: "auto",
                flex: 1,
                padding: "24px",
                maxHeight: "calc(90vh - 80px)",
                bgcolor: "background.paper",
              }}
            >
              {bodyComponent}
            </Box>
          </Box>
        ) : (
          // ✅ Default Layout (no sticky header)
          <Box sx={mergedStyles} className={`rounded-16 max-h-4xl overflow-y-scroll overflow-x-hidden ${bodyStyle}`}>
            {/* Original Header */}
            <Box
              className={`${isSticky && "sticky -top-0 z-999"} flex w-full items-center justify-between px-4 pb-2 pt-2 rounded-t-16`}
              sx={{
                backgroundColor: theme.custom?.primary_icon || "#0967D2",
              }}
            >
              <div className="flex w-full flex-row items-center justify-start">
                {isWarning && (
                  <>
                    <GppMaybeRoundedIcon sx={{ fontSize: "40px", color: "#DE911D" }} />
                    <Box sx={{ m: 1 }} />
                  </>
                )}
                <Typography className="text-xl font-bold text-white" sx={{ color: theme.custom?.heading }}>
                  {headerText}
                </Typography>
              </div>

              <div className="flex gap-x-5">
                {handlePrint && (
                  <IconButton onClick={handlePrint}>
                    <PrintIcon style={{ color: "white", fontSize: "24px" }} />
                  </IconButton>
                )}
                <IconButton onClick={handleClose}>
                  <CloseOutlinedIcon style={{ color: "white", fontSize: "24px" }} />
                </IconButton>
              </div>
            </Box>

            {/* Original Body */}
            <Box
              className="flex flex-col p-2 -z-9999"
              sx={{
                bgcolor: "background.paper",
              }}
            >
              {bodyComponent}
            </Box>
          </Box>
        )}
      </Fade>
    </Modal>
  );
}

export default ModalComponent;
